import React, { Component } from 'react';
import './css/footer.css';

class Footer extends Component {
	constructor(props){
		super(props);
		this.parentContext = props.ctx;
	}
	componentDidMount() {
	}

	componentWillUnmount() {
	}

	render(){
		return (
			<div className="footer-container">
				<div className="footer-header">
					{ window.l10n[window.locale]["landing.welcome"] }
				</div>
				<div className="footer-header-text">
					{ window.l10n[window.locale]["landing.caption2"] }
				</div>
				<div className="horizontal-divider"/>
				<div className="footer-footer">
						<div className="footer-image-l"/>
						<div className="footer-head-l">{ window.l10n[window.locale]["landing.updatedocuments"] }</div>
						<div className="footer-text-l">
							{ window.l10n[window.locale]["landing.caption3"] }
						</div>

						<div className="footer-image-c"/>
						<div className="footer-head-c">{ window.l10n[window.locale]["landing.secureweb"] }</div>
						<div className="footer-text-c">
							{ window.l10n[window.locale]["landing.caption4"] }
						</div>

						<div className="footer-image-r"/>
						<div className="footer-head-r">{ window.l10n[window.locale]["landing.easeofuse"] }</div>
						<div className="footer-text-r">
							{ window.l10n[window.locale]["landing.caption5"] }
						</div>
				</div>
				<div className="footer-foot">
					<div className="footer-foot-l" onClick={ (e)=>{
						console.log("contact us");
					}}>
						{ window.l10n[window.locale]["landing.copyright"] }
					</div>
					<div className="footer-foot-r"  onClick={ (e)=>{
						console.log("mobile version");						
					}}>{ /* window.l10n[window.locale]["landing.mobileversion"] */ }</div>					
				</div>

			</div>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js